export default __webpack_public_path__ + "static/sergei-0bd363b4833ee2bd9dc606301bd5625c.jpg";